// src/components/ClientTestimonials/ClientTestimonials.jsx
import React from "react";
import { FaStar, FaQuoteLeft } from "react-icons/fa";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, EffectCoverflow } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";
import "./ClientTestimonial.css";

const testimonials = [
  {
    stars: 5,
    text:
      "Silvia helped me out of a tight spot. We had to move, and we had junk we needed to have removed. Her team showed up and got rid of hundreds of pounds of stuff in 20 minutes. It was excellent. Silvia is a godsend.",
    name: "Curtis Hackett",
    role: "Renter",
    location: "Puyallup, WA",
  },
  {
    stars: 5,
    text:
      "Silvia is AMAZING! She and her crew Ryan came and took a huge heavy 9 drawer dresser and all the other things we didnt want to move. It was a relief not to ha e to deal with it as well as move and clean the apartment we were leaving! You are awesome Tacoma Junk Removal!",
    name: "Ruth Kringle",
    role: "Business Owner",
    location: "Tacoma, WA",
  },
  {
    stars: 5,
    text:
      "Tacoma’s Junk Removal is truly top-notch! From start to finish, the team was incredibly friendly, worked hard, and maintained a high level of professionalism throughout the entire process. They made everything so easy and stress-free.",
    name: "Flo Rendo",
    role: "Home Owner",
    location: "Tacoma, WA",
  },
  {
    stars: 5,
    text:
      "They were so quick and efficient, I’m so glad they helped us with everything we had to remove from our house!",
    name: "Carissa Hogan",
    role: "Home Owner",
    location: "Tacoma, WA",
  },
];

const starVariants = {
  hidden: { opacity: 0, scale: 0.5 },
  visible: (i) => ({
    opacity: 1,
    scale: 1,
    transition: { delay: i * 0.1, type: "spring", stiffness: 300 },
  }),
};

const cardVariants = {
  hidden: { y: 50, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { type: "spring", stiffness: 100 },
  },
};

const ClientTestimonials = () => {
  return (
    <section className="clientTestimonials">
      {/* decorative bg */}
      <div
        className="clientTestimonials__backgroundPattern"
        aria-hidden="true"
      />

      <div className="clientTestimonials__container">
        {/* Top heading block uses h2 (page likely has an h1 elsewhere) */}
        <motion.div
          className="clientTestimonials__header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true, margin: "-100px" }}
        >
          <span className="clientTestimonials__subtitle">Client Experiences</span>
          <h2 className="clientTestimonials__title">
            What Our Clients Say About Our Junk Removal Services
          </h2>
          <div className="clientTestimonials__divider" />
          <p className="clientTestimonials__description">
            Hear from satisfied homeowners and businesses who've experienced our
            fast, eco-friendly junk removal solutions.
          </p>
        </motion.div>

        <div className="clientTestimonials__sliderWrapper">
          <Swiper
            modules={[Pagination, Autoplay, EffectCoverflow]}
            spaceBetween={30}
            slidesPerView={1}
            pagination={{
              clickable: true,
              el: ".clientTestimonials__pagination",
              type: "bullets",
            }}
            autoplay={{ delay: 7000, disableOnInteraction: false }}
            effect="coverflow"
            grabCursor
            centeredSlides
            coverflowEffect={{
              rotate: 0,
              stretch: 0,
              depth: 100,
              modifier: 2.5,
              slideShadows: false,
            }}
            breakpoints={{
              768: { slidesPerView: 2, effect: "slide" },
              1200: { slidesPerView: 3, effect: "slide", spaceBetween: 30 },
            }}
          >
            {testimonials.map((t, index) => (
              <SwiperSlide key={index}>
                <motion.article
                  className="clientTestimonials__card"
                  variants={cardVariants}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, margin: "-50px" }}
                  aria-label={`Testimonial by ${t.name}`}
                >
                  <div className="clientTestimonials__rating">
                    {[...Array(5)].map((_, i) => (
                      <motion.div
                        key={i}
                        custom={i}
                        initial="hidden"
                        animate="visible"
                        variants={starVariants}
                      >
                        <FaStar
                          className={`clientTestimonials__star ${
                            i < t.stars ? "clientTestimonials__star--filled" : ""
                          }`}
                          aria-hidden="true"
                        />
                      </motion.div>
                    ))}
                  </div>

                  <FaQuoteLeft
                    className="clientTestimonials__quoteIcon"
                    aria-hidden="true"
                  />

                  <blockquote className="clientTestimonials__text">
                    {t.text}
                  </blockquote>

                  <footer className="clientTestimonials__author">
                    {/* Was <h4>; changed to <p> + <cite> to avoid heading-level skip */}
                    <p className="clientTestimonials__authorName">
                      <cite>{t.name}</cite>
                    </p>
                    <p className="clientTestimonials__authorDetails">
                      <span className="clientTestimonials__authorRole">
                        {t.role}
                      </span>
                      <span className="clientTestimonials__authorLocation">
                        {t.location}
                      </span>
                    </p>
                  </footer>

                  <div
                    className="clientTestimonials__cardHover"
                    aria-hidden="true"
                  />
                </motion.article>
              </SwiperSlide>
            ))}
          </Swiper>

          <div className="clientTestimonials__pagination" />
        </div>
      </div>
    </section>
  );
};

export default ClientTestimonials;
